enum ProcessStatuses {
	Started = "started",
	Processing = "processing",
	Cancelled = "cancelled",
	Completed = "completed",
	Failed = "failed",
}

export default ProcessStatuses;
